module.exports = __webpack_public_path__ + "img/telegram.652117b7.svg";